import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const downloadInforXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadInforXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadCfsMagXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadCfsMagXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadClientXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadClientXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadContactXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadContactXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadBankXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadBankXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const downloadAddressXml = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "blob",
      serviceHost + "/xmlDownload/downloadAddressXml",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
